import { useEffect, useState } from "react";
import { useDragDropManager } from "react-dnd";

interface IGlobalDragDropState {
  isDragging: boolean;
}

export const useGlobalDragDropMonitor = (): IGlobalDragDropState => {

  const manager = useDragDropManager();
  const monitor = manager.getMonitor();

  const [state, setState] = useState<IGlobalDragDropState>({
    isDragging: monitor.isDragging()
  });

  useEffect(() => {
    const unsubscribe = monitor.subscribeToStateChange(() => {
      setState(s => ({
        ...s,
        isDragging: monitor.isDragging()
      }));
    });
    return unsubscribe;
  }, [monitor])

  return state;
}